import { createFileRoute, redirect } from "@tanstack/react-router";
import { auth } from "@/lib/auth";
import { useAuthStore } from "@/stores/useAuthStore";
import { ensureMyPermissions } from "@/hooks/api/authorization/useAuthorization";
import { hasAnyCapability } from "@/lib/permissions";

export const Route = createFileRoute("/")({
  loader: async () => {
    const token = auth.getToken();
    if (token) {
      const result = await useAuthStore.getState().getProfile();
      if (result.success) {
        // Same rule as the admin shell's guard: any capability beyond the
        // baseline reaches it.
        const capabilities = await ensureMyPermissions();
        throw redirect({
          to: hasAnyCapability(capabilities) ? "/admin" : "/user",
        });
      }
      auth.resetToken();
    }
    throw redirect({ to: "/login" });
  },
  component: Index,
});

function Index() {
  return <div>Home </div>;
}
